import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  itemsLabel?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  itemsLabel
}) => {
  const safeTotalPages = Math.max(totalPages, 1);

  return (
    <div className="flex items-center justify-between border-t border-border px-6 py-4 bg-muted/10">
      <div className="text-sm text-muted-foreground font-semibold">
        {itemsLabel ? itemsLabel : `Página ${currentPage} de ${safeTotalPages}`}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
          className="inline-flex items-center justify-center p-2 rounded-lg border border-border bg-white text-gray-700 hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm"
          title="Página Anterior"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        {/* We can show page numbers if we want, but simple prev/next is good for now */}
        <div className="flex items-center gap-1 px-2 font-medium text-sm text-[#212121]">
          {currentPage} / {safeTotalPages}
        </div>
        <button
          onClick={() => onPageChange(Math.min(currentPage + 1, safeTotalPages))}
          disabled={currentPage === safeTotalPages}
          className="inline-flex items-center justify-center p-2 rounded-lg border border-border bg-white text-gray-700 hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed transition shadow-sm"
          title="Siguiente Página"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  );
};
